import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import Portfolio from '../components/sections/Portfolio';
import WhyUs from '../components/sections/WhyUs';
import Testimonials from '../components/sections/Testimonials';
import Team from '../components/sections/Team';
import Contact from '../components/sections/Contact';

const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Portfolio />
      <WhyUs />
      <Testimonials />
      <Team />
      <Contact />
    </>
  );
};

export default HomePage;
